/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import intl from 'react-intl-universal';

import {formatSmartAbsoluteDate} from '../../helpers/DateHelper';

class OutageCardTimeHeader extends React.Component {

    outage() {
        return this.props.outage;
    }

    renderHeader() {
        let outage = this.outage();

        let dimLength = outage.mainDimensionPath.length;
        let title = outage.mainDimensionPath[dimLength - 1];
        let subtitle = outage.mainDimensionPath.slice(0, dimLength - 1).reverse().join(', ');

        return (
            <div className="media-body">
                <h3 className="h6 mb-0">{title}</h3>
                <div className="small">
                    {subtitle}
                </div>
            </div>
        );
    }

    renderDate() {
        let outage = this.outage();
        return (
            <small className="text-muted">{formatSmartAbsoluteDate(outage.startTime)}</small>
        );
    }

    renderState() {
        let outage = this.outage();

        if (outage.active) {
            return (
                <span className="badge badge-danger ml-2">{intl.get('outage_ongoing')}</span>
            )
        } else if (outage.recent) {
            return (
                <span className="badge badge-warning ml-2">{intl.get('outage_today')}</span>
            )
        } else {
            return '';
        }
    }

    render() {
        return (
            <div className="d-block mb-3">
                {this.renderDate()}
                {this.renderState()}
            </div>
        );
    }
}

export default OutageCardTimeHeader;